module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAAP///2ZmZiH5BAAAAAAALAAAAAAMAAwAAAITjI+pCu0bGjRyVnhXZmDG7oVLAQA7"